module.exports = ".nav-tabs-custom > .nav-tabs > li {\n  border-top-width: 0;\n}\n\n.nav-tabs-custom > .nav-tabs > li.active {\n  border-top-width: 3px;\n}\n"